import { render } from "./role-select.vue?vue&type=template&id=6674e8fa"
import script from "./role-select.vue?vue&type=script&lang=js"
export * from "./role-select.vue?vue&type=script&lang=js"

import "./role-select.vue?vue&type=style&index=0&id=6674e8fa&lang=css"

import exportComponent from "/var/jenkins_home/workspace/tl-demo-web_v2.0.9.4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__